// localStorageUtils.js

const LOCAL_STORAGE_KEY = "reduxState";
const LOGIN_TIMESTAMP_KEY = "loginTimestamp";
const EXPIRY_DAYS = 3;

export const hasCompleteUserData = () => {
  try {
    // First check if data is expired
    if (isLocalStorageExpired()) {
      clearLocalStorage();
      return false;
    }

    const serializedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!serializedState) return false;

    const state = JSON.parse(serializedState);
    
    // Check if all essential data exists
    const hasToken = state?.user?.token;
    const hasUser = state?.user?.user;
    const hasStoreData = state?.store?.store || state?.store?.storesList?.length > 0;
    
    return hasToken && hasUser && hasStoreData;
  } catch (e) {
    console.error("Error checking user data", e);
    return false;
  }
};

// Get stored state for auto-login
export const getStoredStateForAutoLogin = () => {
  try {
    if (!hasCompleteUserData()) return null;
    
    const serializedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    return JSON.parse(serializedState);
  } catch (e) {
    return null;
  }
};
// Save state with timestamp
export const saveStateToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(LOCAL_STORAGE_KEY, serializedState);
    
    // Save login timestamp
    const loginTimestamp = new Date().getTime();
    localStorage.setItem(LOGIN_TIMESTAMP_KEY, loginTimestamp.toString());
    
    console.log("✅ State saved to localStorage with timestamp");
  } catch (e) {
    console.error("Error saving state to localStorage", e);
  }
};

// Load state and check expiry
export const loadStateFromLocalStorage = () => {
  try {
    // Check if data has expired
    if (isLocalStorageExpired()) {
      clearLocalStorage();
      return undefined;
    }

    const serializedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!serializedState) return undefined;
    
    return JSON.parse(serializedState);
  } catch (e) {
    console.error("Error loading state from localStorage", e);
    return undefined;
  }
};

// Check if localStorage data has expired
export const isLocalStorageExpired = () => {
  try {
    const loginTimestamp = localStorage.getItem(LOGIN_TIMESTAMP_KEY);
    
    if (!loginTimestamp) {
      return true; // No timestamp found, consider expired
    }

    const loginTime = parseInt(loginTimestamp);
    const currentTime = new Date().getTime();
    const daysDifference = (currentTime - loginTime) / (1000 * 60 * 60 * 24);

    return daysDifference > EXPIRY_DAYS;
  } catch (e) {
    console.error("Error checking localStorage expiry", e);
    return true; // If there's an error, clear the storage
  }
};



// Clear all localStorage data
export const clearLocalStorage = () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
    localStorage.removeItem(LOGIN_TIMESTAMP_KEY);
    localStorage.removeItem("reduxState"); // legacy key
    console.log("🗑️ LocalStorage cleared (auto-expiry after 3 days)");
  } catch (e) {
    console.error("Error clearing localStorage", e);
  }
};

// Manual logout function that clears everything
export const manualLogout = () => {
  clearLocalStorage();
  window.location.href = "/"; // Redirect to login page
};

// Initialize check on app load
export const initializeStorageCheck = () => {
  if (isLocalStorageExpired()) {
    clearLocalStorage();
  }
};